import {
    api_getPendingAppointments,
    api_retrieveAppointments,
    api_searchAppointments
} from "./appointmentList.api";
import {
    setUpcomingAppointments,
    setPastAppointments,
    loadMorePastAppointments,
    loadMoreUpcomingAppointments
} from "./appointmentList.reducers";

export const loadMorePastAppts = params => dispatch => (
    api_retrieveAppointments(params).then(res => {
        dispatch(loadMorePastAppointments(res));
        return res;
    })
);

export const setPastAppts = params => dispatch => (
    api_retrieveAppointments(params).then(res => {
        dispatch(setPastAppointments(res));
        return res;
    })
);

export const searchPastAppointments = params => dispatch => (
    api_searchAppointments(params).then(res => {
        dispatch(setPastAppointments(res));
        return res;
    })
);

export const retrieveAppointments = params => dispatch => (
    api_retrieveAppointments(params).then(res => {
        return res;
    })
);

export const getPendingAppointments = params => dispatch => (
    api_getPendingAppointments(params).then(res => {
        return res;
    })
);

export const loadMoreFutureAppointments = list => dispatch => (
    dispatch(loadMoreUpcomingAppointments(list))
);

export const setFutureAppointments = list => dispatch => (
    dispatch(setUpcomingAppointments(list))
);
